import { 
    MessageResponseDto, 
    GetTransactionServiceDto, 
    CreateTransactionServiceDto, 
    EditTransactionServiceDto,
    TransactionServiceControllerGet200Response,
    TransactionServiceApiFp,
    DeleteTransactionServiceDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTransactionServiceModel = TransactionServiceControllerGet200Response;
export type GetTransactionServiceModel = GetTransactionServiceDto;
export type MutateResponseTransactionServiceModel = MessageResponseDto;
export type CreateTransactionServiceModel = CreateTransactionServiceDto;
export type UpdateTransactionServiceModel = EditTransactionServiceDto;
export type DeleteTransactionServiceModel = DeleteTransactionServiceDto;

export const apiTransactionServiceFp = TransactionServiceApiFp(apiConfig);
export const getTransactionServiceController = apiTransactionServiceFp.transactionServiceControllerGet;
export const createTransactionServiceController = apiTransactionServiceFp.transactionServiceControllerCreate;
export const updateTransactionServiceController = apiTransactionServiceFp.transactionServiceControllerEdit;
export const deleteTransactionServiceController = apiTransactionServiceFp.transactionServiceControllerDelete;
export const checkoutTransactionServiceController = apiTransactionServiceFp.transactionServiceControllerCheckout;

export const QueryKeyTransactionService = QueryKey.TransactionService;